import {PageDTO} from "../pagination.types";
import {Patient} from "app/features/patient/patient.types";


export const daysInAYear = 365.242374;

export interface Medic{
    id: string,
    experience: 0,
    user: string
}

export interface User {
    // model data
    /** ID of user */
    id: string;
    firstName: string;
    lastName: string;
    dateOfBirth: any;
    cnp:string;
    /** ID of user in cognito */
    cognitoUsername: string;
    /** Path of user profile image in AWS S3 */
    userProfilePath: string;
    email: string;
    phoneNumber: string;
    genderType: GenderType;
    /** ID of user calendar */
    calendar: string;
    /** IDs of roles taht user has */
    userRole: string[];
    /** ID of notification settings for this user */
    notificationSettings: string;
    // extra
    avatar?: any | null; //blob when avatar image is fetched
    background?: string | null;
    status?:string;
    patientInfo?: Patient | null;
    medicInfo: Medic | null;
}

export interface SlimUser{
    firstName: string,
    lastName: string,
    phoneNumber: string,
    gender: GenderType
}

export class UserPageDTO extends PageDTO{
    content: User[];
}

export class ExtendedUser{
    userDTO: User;
    userContactDTO: ContactInfo;

}

export class UserExtendedPageDTO extends PageDTO{
    content: ExtendedUser[];
}

export interface UserCreationResponse{
    userId: string,
    calendarId: string
}

export interface ContactInfo {
    // model data
    "id": string;
    "postalCode": number;
    "city": string;
    "country": string;
    "emergencyContactName": string;
    "emergencyContactPhone": string;
    "address": string;
    "user": string;
}

export interface UserSearchCriteria {
    // For example if you are interested to only search by roleName, for UserByQuerySearchDTO only pass the roleName.
    // If you pass more than one criteria an OR function will be used. If you pass an empty string for a search
    // criteria you will match it all the time since the underlying search is using contains.
    "email"?: string,
    "firstName"?: string,
    "lastName"?: string,
    "phoneNumber"?: string,
    roleName?: string
}

export function getNewContactInfo():ContactInfo{
    return {
        address: "",
        city: "",
        country: "",
        emergencyContactName: "",
        emergencyContactPhone: "",
        id: "",
        postalCode: null,
        user: null
    }
}

export function getUserInstance():User{
    return {
            id: "",
            firstName: "",
            lastName: "",
            dateOfBirth: "any",
            cnp: "",
            cognitoUsername: "",
            userProfilePath: "",
            email: "",
            phoneNumber: "",
            genderType: GenderType.NOT_SPECIFIED,
            calendar: "",
            userRole: [],
            notificationSettings: "",
            patientInfo: null,
            medicInfo: null
        }
}

export enum GenderType{
    MALE='MALE',
    FEMALE='FEMALE',
    NOT_SPECIFIED='NOT_SPECIFIED'
}
